import { render, staticRenderFns } from "./SaleManDetail.vue?vue&type=template&id=22cb1d44&scoped=true&"
import script from "./SaleManDetail.vue?vue&type=script&lang=ts&"
export * from "./SaleManDetail.vue?vue&type=script&lang=ts&"
import style0 from "./SaleManDetail.vue?vue&type=style&index=0&id=22cb1d44&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cb1d44",
  null
  
)

export default component.exports